import { PROJECTMAIL_WS_CALL_NEW_TICKET, PROJECTMAIL_WEBSOCKETERROR_RELOAD } from "../../actions/projectmail";
import { GROUP_ID_EVENT, GROUP_ID_WEBCAST } from "../../config";

const passcodeMiddleware = store => {
  return next => async action => {
    if (action.type === PROJECTMAIL_WEBSOCKETERROR_RELOAD && store.getState().oauth.notificationPermission) {
      const notify = () => new Notification(store.getState().ui.translate.webSocketError.replace("{0}", "10"));
      notify();
    }
    if (action.type === PROJECTMAIL_WS_CALL_NEW_TICKET && store.getState().oauth.notificationPermission) {
      const ticket = action.ticketObject.Ticket;
      if (
        ticket.group === GROUP_ID_EVENT &&
        ticket.tags.indexOf("#urgent") === -1 &&
        store.getState().projectmail.activeBellsForTicketType.indexOf("event") > -1
      ) {
        const notify = () => new Notification(store.getState().ui.translate.notification.replace("{0}", "Event"));
        notify();
      }
      if (
        ticket.group === GROUP_ID_WEBCAST &&
        ticket.tags.indexOf("#urgent") === -1 &&
        store.getState().projectmail.activeBellsForTicketType.indexOf("webcast") > -1
      ) {
        const notify = () => new Notification(store.getState().ui.translate.notification.replace("{0}", "Webcast"));
        notify();
      }
      if (
        ticket.tags.indexOf("#urgent") > -1 &&
        store.getState().projectmail.activeBellsForTicketType.indexOf("urgent") > -1
      ) {
        const notify = () => new Notification(store.getState().ui.translate.notification.replace("{0}", "Urgent"));
        notify();
      }
    }
    next(action);
  };
};

export default passcodeMiddleware;
